module.exports = __webpack_public_path__ + "static/media/checkWhite.73d419b5.svg";